import React, { Component } from "react";

class Popup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      flag: false
    };
  }

  // 팝업창 닫기
  closePopup = (event) => {
    let className = event.target.parentNode.getAttribute("class");
    if (className.indexOf("current")) {
      className = className.replace(" current", "");
      event.target.parentNode.setAttribute("class", className);
    }
  };

  onClickRespin = (event) => {
    event.preventDefault();
    let className = event.target.parentNode.parentNode.getAttribute("class");
    if (className.indexOf("current")) {
      className = className.replace(" current", "");
      event.target.parentNode.parentNode.setAttribute("class", className);
    }

    this.props.onClick();
  };

  render() {
    const self = this;

    if (this.props.eventResultInfo) {
      document.getElementById('currentPoint').innerText = this.props.eventResultInfo.pointData.currentPoint;
    }

    let node = null;
    let defaultNode = (
      <div className="re_popup_w_already">
        <h5>
          <span className="roulette_icn rep_title_image_already">
            <i className="ir">오늘은 이미 참여하셨습니다</i>
          </span>
        </h5>
        <div className="rep_info">현재
          <em className="rep_info_point_blue notranslate">
            {self.props.userId}
          </em>
          님의<br />잔여포인트는
          <em className="rep_info_point_orange notranslate" id="currentPoint">
            {self.props.participantInfo ? this.props.participantInfo.pointData.currentPoint : 0}P
            </em>입니다.
        </div>
        <div className="rep_text">
          <em className="rep_text_point">
            S포인트를 사용해서<br />계속 이벤트에 참여해보세요!
            </em>
            </div>
        <div className="rep_button_w">
          <a href="#none" className="rep_button_text_pink" onClick={this.onClickRespin} target="_blank">S포인트로 <br />룰렛돌리기</a>
          <a href="//m.sbs.co.kr/myzone/events.do" className="rep_button_text_black" target="_blank">참여내역 <br />확인하기</a>
        </div>
        {/** 팝업창 닫기 */}
        <button className="rep_button_close" onClick={this.closePopup}>닫기</button>
      </div>
    );

    if (this.props.eventResultInfo !== null) {
      if (this.props.eventResultInfo.response.status === 200) {
          if (self.props.eventResultInfo.goodsInfo.goodsType === "POINT") {
            node = <div className="re_popup_w_point">
                <h5>
                  <span className="roulette_icn rep_title_image_win"><i className="ir">축하합니다</i></span>
                  <div className="rep_title_text"><em className="rep_title_text_point notranslate">{this.props.eventResultInfo !== null ? this.props.eventResultInfo.goodsInfo.goodsTitle : ''}</em>에당첨되었습니다!</div>
                </h5>
                {/** 운영이미지 : 포인트 이미지 */}
                <img src={self.props.eventResultInfo.goodsInfo.pcImgUrl || " "} alt={self.props.eventResultInfo.goodsInfo.goodsDescriptionPc || "경품 이미지"} className="rep_gift_image" />
                <div className="rep_text"> 당첨내역은 <a href="//m.sbs.co.kr/myzone/events.do" className="rep_text_point">마이존 &gt; 이벤트 참여내역 </a>에서 확인 가능합니다.</div>
                <div className="rep_button_w">
                  <a href="//m.sbs.co.kr/myzone/events.do" className="rep_button_text_black" target="_blank">참여내역 <br />확인하기</a>
                  <a href="//m.sbs.co.kr/pass/pass.do" className="rep_button_text_blue" target="_blank"> VOD패키지 <br />혜택보기 </a>
                </div>
                <button className="rep_button_close" onClick={this.closePopup}>
                  닫기
                </button>
              </div>;
          } else if (self.props.eventResultInfo.goodsInfo.goodsType === "GIFTICON") {
            node = <div className="re_popup_w_gifticon">
                <h5><span className="roulette_icn rep_title_image_win"><i className="ir">축하합니다</i></span>
                  <div className="rep_title_text"><em className="rep_title_text_point">{self.props.eventResultInfo.goodsInfo.goodsTitle}</em>에 당첨되었습니다!</div>
                </h5>
                <img src={self.props.eventResultInfo.goodsInfo.pcImgUrl || " "} alt={self.props.eventResultInfo.goodsInfo.goodsDescriptionPc || "경품 이미지"} className="rep_gift_image" />
                <div className="rep_text">당첨내역은 <a href="//m.sbs.co.kr/myzone/events.do" className="rep_text_point"> 마이존 &gt; 이벤트 참여내역 </a>에서 확인 가능합니다.</div>
                <div className="rep_button_w">
                  <a href="//m.sbs.co.kr/myzone/events.do" className="rep_button_text_black" target="_blank" >참여내역 <br />확인하기</a>
                  <a href="//m.sbs.co.kr/pass/pass.do" className="rep_button_text_blue" target="_blank">VOD패키지 <br />혜택보기</a>
                </div>
                <button className="rep_button_close" onClick={this.closePopup}>닫기</button>
              </div>;
          } else {
            node = (
              <div className="re_popup_w_fail">
                <h5><span className="roulette_icn rep_title_image_fail"><i className="ir">아쉽지만</i></span><div className="rep_title_text"><em className="rep_title_text_point">꽝</em>에 당첨되었습니다!</div></h5>
                <div className="rep_info">현재<em className="rep_info_point_blue notranslate">{self.props.userId}</em>님의<br />잔여포인트는<em className="rep_info_point_orange notranslate">{this.props.eventResultInfo.pointData.currentPoint || 0}P</em>입니다.</div>
                <div className="rep_text"><em className="rep_text_point">S포인트를 사용해서<br />계속 이벤트에 참여해보세요!</em></div>
                <div className="rep_button_w">
                  <a href="#none" className="rep_button_text_pink" onClick={this.onClickRespin} target="_blank">S포인트로 <br />룰렛돌리기</a>
                  <a href="//m.sbs.co.kr/myzone/events.do" className="rep_button_text_black" target="_blank">참여내역 <br />확인하기</a>
                </div>
                <button className="rep_button_close" onClick={this.closePopup}>닫기</button>
              </div>
            );
          }
        }
    }

    return (
      <div>
        {defaultNode}
        {node}
      </div>
    );
  }
}

export default Popup;
